import { createApp } from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import App from './App.vue'
import router from './router'

import { Api } from './store/api'
import { Paypay } from './store/paypay'

import {Amplify, AuthModeStrategyType } from 'aws-amplify'
import awsconfig from './aws-exports'

Amplify.configure({ ...awsconfig, DataStore: { authModeStrategyType: AuthModeStrategyType.MULTI_AUTH }});

import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';
applyPolyfills().then(() => {
  defineCustomElements(window);
});


dayjs.locale('ja')

import BootstrapVue3 from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faLeaf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import liff from '@line/liff/dist/lib'

library.add(faLeaf)

const main = async() => {

  const app = createApp(App)

  app.use(BootstrapVue3)
  app.component('faIcon', FontAwesomeIcon )
  app.provide('dayjs', dayjs)
  app.provide('api', Api)
  app.provide('paypay', Paypay)

  app.config.globalProperties.$filters = {
    currencyUSD(value: number) {
      return '$' + value
    }
  }

  app.use(router).mount('#app')
}
main();
